export type ImageType =
  | 'Clinical'
  | 'Dermoscopy'
  | 'Follow-up dermoscopy'
  | 'Overview'
  | 'Close up';

/**
 * Simple enum for specifying the origin of an image.
 */
export enum ImageOriginEnum {
  Training = 'training',
  Clinical = 'clinical',
}

export const PhotoTypes = [
  'Clinical',
  'Dermoscopy',
  'Follow-up dermoscopy',
  'Overview',
  'Close up',
] as const;
export type PhotoType = (typeof PhotoTypes)[number];

export const PhotoTypesEnum = {
  closeUp: 'Close up',
  clinical: 'Clinical',
  dermoscopy: 'Dermoscopy',
  overview: 'Overview',
} as const;

export const SimpleImageTypes = [
  'Overview',
  'Close up',
  'Dermoscopy',
] as const satisfies PhotoType[];

export type SimplifiedImageType = (typeof SimpleImageTypes)[number];

export function simplifyImageType(imageType: PhotoType): SimplifiedImageType {
  switch (imageType) {
    case 'Clinical':
    case 'Overview':
      return 'Overview';
    case 'Dermoscopy':
    case 'Follow-up dermoscopy':
      return 'Dermoscopy';
    case 'Close up':
      return 'Close up';
    default:
      return undefined;
  }
}
